(function () {
  "use strict";

  var RELOAD_GUARD_KEY = "dsd.auth-session-freshness.reload";
  var RELOAD_STATE_KEY = "dsd.auth-session-freshness.reload-state";
  var AUTH_KNOWN_KEY = "dsd.auth-session-freshness.known-authenticated";
  var RELOAD_GUARD_MS = 1200;
  var RELOAD_WINDOW_MS = 15000;
  var MAX_RELOADS = 3;
  var AUTH_KNOWN_MS = 8 * 60 * 60 * 1000;
  var SESSION_STATUS_ENDPOINT =
    "/apps/dsd-firebase-custom-token?bridgeRoute=%2Fsession-status";

  function serverRenderedAuthenticated() {
    return document.documentElement.classList.contains(
      "dsd-shopify-authenticated",
    );
  }

  function returnedFromCustomerAccount() {
    if (!document.referrer) return false;
    try {
      var host = new URL(document.referrer).hostname.toLowerCase();
      return (
        host === "account.detroitskydaddy.com" ||
        host.endsWith(".account.detroitskydaddy.com") ||
        host === "shopify.com" ||
        host.endsWith(".shopify.com") ||
        host === "shop.app" ||
        host.endsWith(".shop.app") ||
        (host === window.location.hostname.toLowerCase() &&
          new URL(document.referrer).pathname.indexOf("/account") === 0)
      );
    } catch (error) {
      return false;
    }
  }

  function reloadOnce(reason) {
    var now = Date.now();
    var previous = 0;
    var state = { startedAt: now, count: 0 };

    try {
      previous = Number(window.sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
      var stored = JSON.parse(
        window.sessionStorage.getItem(RELOAD_STATE_KEY) || "null",
      );
      if (stored && Number(stored.startedAt) && Number(stored.count) >= 0) {
        state = stored;
      }
    } catch (error) {}

    if (now - Number(state.startedAt || 0) > RELOAD_WINDOW_MS) {
      state = { startedAt: now, count: 0 };
    }

    if (Number(state.count || 0) >= MAX_RELOADS) {
      document.documentElement.setAttribute(
        "data-dsd-auth-session-freshness",
        "signed-session-server-shell-pending",
      );
      return;
    }

    if (previous && now - previous < RELOAD_GUARD_MS) {
      window.setTimeout(function () {
        reloadOnce(reason + "-guard-release");
      }, RELOAD_GUARD_MS - (now - previous) + 50);
      return;
    }

    state.count = Number(state.count || 0) + 1;

    try {
      window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
      window.sessionStorage.setItem(RELOAD_STATE_KEY, JSON.stringify(state));
    } catch (error) {}

    document.documentElement.setAttribute(
      "data-dsd-auth-session-freshness",
      reason,
    );
    var url = new URL(window.location.href);
    url.searchParams.set("dsd_auth_refresh", String(now));
    window.location.replace(url.toString());
  }

  function rememberAuthenticatedShell() {
    try {
      window.sessionStorage.setItem(AUTH_KNOWN_KEY, String(Date.now()));
      window.localStorage.setItem(AUTH_KNOWN_KEY, String(Date.now()));
      if (serverRenderedAuthenticated()) {
        window.sessionStorage.removeItem(RELOAD_GUARD_KEY);
        window.sessionStorage.removeItem(RELOAD_STATE_KEY);
      }
    } catch (error) {}
  }

  function recentlyAuthenticated() {
    try {
      var recorded = Math.max(
        Number(window.sessionStorage.getItem(AUTH_KNOWN_KEY) || 0),
        Number(window.localStorage.getItem(AUTH_KNOWN_KEY) || 0),
      );
      return !!recorded && Date.now() - recorded < AUTH_KNOWN_MS;
    } catch (error) {
      return false;
    }
  }

  function forgetAuthenticatedShell() {
    try {
      window.sessionStorage.removeItem(AUTH_KNOWN_KEY);
      window.localStorage.removeItem(AUTH_KNOWN_KEY);
      window.sessionStorage.removeItem(RELOAD_GUARD_KEY);
      window.sessionStorage.removeItem(RELOAD_STATE_KEY);
    } catch (error) {}
  }

  function verifySignedShopifySession(reason, retryDelayMs) {
    window
      .fetch(SESSION_STATUS_ENDPOINT, {
        method: "POST",
        credentials: "include",
        cache: "no-store",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          bridgeRoute: "/session-status",
          intent: "auth-shell-freshness",
        }),
      })
      .then(function (response) {
        if (!response.ok) throw new Error("session-status-" + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (payload && payload.authenticated === true) {
          rememberAuthenticatedShell();
          reloadOnce(reason + "-signed-session");
          return;
        }

        if (retryDelayMs > 0) {
          window.setTimeout(function () {
            verifySignedShopifySession(reason + "-retry", 0);
          }, retryDelayMs);
          return;
        }

        forgetAuthenticatedShell();
      })
      .catch(function () {
        // Preserve the marker on transient failures so the next navigation can retry.
      });
  }

  window.addEventListener("pageshow", function (event) {
    if (serverRenderedAuthenticated()) {
      rememberAuthenticatedShell();
      return;
    }

    if (event.persisted && recentlyAuthenticated()) {
      verifySignedShopifySession("bfcache-public-shell", 0);
      return;
    }

    if (returnedFromCustomerAccount()) {
      window.setTimeout(function () {
        if (!serverRenderedAuthenticated()) {
          verifySignedShopifySession("customer-account-return", 1200);
        }
      }, 350);
      return;
    }

    if (recentlyAuthenticated()) {
      verifySignedShopifySession("known-session-public-shell", 0);
    }
  });

  new MutationObserver(function () {
    if (serverRenderedAuthenticated()) rememberAuthenticatedShell();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });

  window.addEventListener("dsd:shopify-logout", forgetAuthenticatedShell);

  document.addEventListener("visibilitychange", function () {
    if (
      document.visibilityState === "visible" &&
      !serverRenderedAuthenticated() &&
      recentlyAuthenticated()
    ) {
      verifySignedShopifySession("known-session-visible-public-shell", 0);
    }
  });
})();
